import { render, staticRenderFns } from "./Dentify.vue?vue&type=template&id=6ab83303"
import script from "./Dentify.vue?vue&type=script&lang=js"
export * from "./Dentify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports